export enum EnComponentState {
  LOADING = 'loading',
  LOOKUP = 'lookup',
  ERROR = 'error',
  IDLE = 'idle',
}
